/* tslint:disable */
/* eslint-disable */
/**
 * David Master Api
 * db: david-master
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the ResetPasswordRequestDTO interface.
 */
export function instanceOfResetPasswordRequestDTO(value) {
    let isInstance = true;
    return isInstance;
}
export function ResetPasswordRequestDTOFromJSON(json) {
    return ResetPasswordRequestDTOFromJSONTyped(json, false);
}
export function ResetPasswordRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}
export function ResetPasswordRequestDTOToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'token': value.token,
        'password': value.password,
    };
}
